import React, {useRef, useState} from "react"
import {Controller, useForm} from "react-hook-form";
import {Col, Form, Row} from 'react-bootstrap'
import {
    alphaNumericValidation,
    checkEmptySpaces,
    EmailValidation,
    maxLength,
    PasswordValidation,
    PhoneValidation,
    Required
} from "../../../utils/patterns";
import TextInput from "../../../components/common/input-field/TextInput";
import "./signup.scss"
import ThemeButton from "../../../components/common/theme-button/ThemeButton";

import PasswordInput from "../../../components/common/password-field/PasswordInput";
import {useNavigate} from "react-router";
import PhoneField from "../../../components/common/phone-field/PhoneField";
import ThemeModal from "../../../components/common/modals/theme-modal/ThemeModal";
import PrivacyPolicy from "../policy/PrivacyPolicy";
// import VenueLocationOtp from "../../account-setup/venue-location/VenueLocationOtp";
import {useUser} from "../../../providers/UserContext";


export default function Signup() {
    const [privacyModal, setPrivacyModal] = useState(false);
    const [termsModal, setTermsModal] = useState(false);
    const[otp,setOtp] = useState(false);
    const [sucessModal, setSucessModal] = useState(false);
    const [verifyDone, setVerifyDone] = useState(false);
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate()

    const {setFirstLogin, firstLogin} = useUser()

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    })
    const onSubmit = async (data) => {
        setLoader(true)
        setTimeout(()=>{
            setLoader(false)
            setOtp(true)
            setFirstLogin(true)
            navigate('/otp-verfication-password', { state: { redirect: '/account-created' , hello : 'hello' } });
        }, 2000)
    }
    const password = useRef({})
    password.current = watch('password', '')
    const gender=[
        {
            value: 1,
            label: 'Male',
        },
        {
            value: 2,
            label: 'Female',
        },
        {
            value: 3,
            label: 'Other',
        },
    ]

    return(
        <div className={'signup'}>
            <h3>Sign Up</h3>
            <h5>Let’s get you into the app!</h5>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    {/*<Col md={12}>*/}
                    {/*    <div className={'form-avatar'}>*/}
                    {/*        <ThemeUpload/>*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                    <Col md={12}>
                        <div className={'dfields'}>
                            <Controller
                                name="f_name"
                                defaultValue={''}
                                control={control}
                                rules={{required: Required, maxLength: maxLength(100), pattern:alphaNumericValidation, validate: checkEmptySpaces,}}
                                render={({field: {name, ...field}}) => (
                                    <TextInput
                                        placeholder={'Name'}
                                        label={'First Name'}
                                        type={'text'}
                                        field={field}
                                        errors={errors.f_name}
                                        className={'required'}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    {/*<Col md={6}>*/}
                    {/*    <div className={'dfields'}>*/}
                    {/*        <Controller*/}
                    {/*            name="l_name"*/}
                    {/*            defaultValue={''}*/}
                    {/*            control={control}*/}
                    {/*            rules={{required: Required, maxLength: maxLength(100), pattern:alphaNumericValidation,  validate: checkEmptySpaces}}*/}
                    {/*            render={({field: {name, ...field}}) => (*/}
                    {/*                <TextInput*/}
                    {/*                    placeholder={'Your last name'}*/}
                    {/*                    label={'Last Name'}*/}
                    {/*                    type={'text'}*/}
                    {/*                    field={field}*/}
                    {/*                    errors={errors.l_name}*/}
                    {/*                    className={'required'}*/}
                    {/*                />*/}
                    {/*            )}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                </Row>
                <div className={'dfields'}>
                    <Controller
                        name="email"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required,pattern:EmailValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <TextInput
                                placeholder={'Your email here'}
                                label={'Email Address'}
                                type={'email'}
                                field={field}
                                errors={errors.email}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="phone"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:PhoneValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <PhoneField
                                label={'Phone'}
                                className={'required'}
                                field={field}
                                errors={errors.phone}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="password"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Enter your password'}
                                label={'Password'}
                                field={field}
                                errors={errors.password}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'}>
                    <Controller
                        name="cpassword"
                        defaultValue={''}
                        control={control}
                        rules={{
                            validate: (value) => value == password.current || 'The password does not match',
                        }}
                        render={({field: {name, ...field}}) => (
                            <PasswordInput
                                placeholder={'Enter your password'}
                                label={'Confirm Password'}
                                field={field}
                                errors={errors.cpassword}
                                className={'required'}
                            />
                        )}
                    />
                </div>
                <div className={'dfields'} style={{marginTop:38}}>
                    <ThemeButton
                        text={'Sign up'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        loader={loader}
                    />
                </div>
                <div>
                    <p onClick={()=>{navigate('/login')}} className={'other-option mt-4'}>Have an account?  <span>Sign In</span></p>
                </div>
                <ThemeModal
                    modalHeading={'Terms & Conditions'}
                    show={termsModal}
                    close={setTermsModal}
                    children={<PrivacyPolicy/>}
                    headingSize={24}
                    className={'with-shadow'}
                />
                <ThemeModal
                    modalHeading={'Privacy Policy'}
                    show={privacyModal}
                    close={setPrivacyModal}
                    children={<PrivacyPolicy/>}
                    headingSize={24}
                    className={'with-shadow'}
                />
            </Form>
        </div>
    )
}